const exploreSection = $('#explore-section');

const addExploreAnimation = () => {
  const gradientConfig = {
    gradient: 'linear-gradient(127deg, #081B48 0%, #8AD1DA 50%, #081B48 100%);',
    start: 120,
    end: 0,
  };

  const sectionInTL = gsap.timeline({
    paused: true,
  });

  sectionInTL.add(
    animateSectionTopperIn({
      sectionParent: exploreSection,
      gradientConfig: gradientConfig,
    }).play(),
    0
  );

  const exploreContentELements = exploreSection.find('.explore-section-image, .explore-card-parent');

  sectionInTL.add(elementInAnimationYWOpacity(exploreContentELements, '100%', 0, 1, 1, 1, 0, 0.1, 'start', 'pageInEasing', 'pageInEasing').play(), 0.1);
  /*
  exploreContentELements.each(function (index) {
    //sectionInTL.add(addElementInAnimation($(this), '100%', 1, 0).play(), 0.1 * index + 0.1);
  });
  */

  return sectionInTL;
};

const addCardHovers = () => {
  const exploreCards = exploreSection.find('.explore-card-parent');
  exploreCards.each(function () {
    const exploreCardIcons = $(this).find('.explore-card-icon');
    $(this).on('mouseenter', () => {
      arrowAnimation(exploreCardIcons, 1, 1);
    });

    $(this).on('mouseleave', () => {
      arrowAnimation(exploreCardIcons, 1, 0);
    });
  });
};

const initExplore = () => {
  addCardHovers()
  const exploreTL = addExploreAnimation();
  ScrollTrigger.create({
    trigger: exploreSection,
    start: 'top top+=120%',
    end: 'top top',
    once: true,
    onUpdate: (self) => {
      exploreTL.progress(self.progress);
    },
  });
}

/*
$(window).on('load', () => {
  initExplore();
});
*/

addSectionObserver(exploreSection, initExplore, false);